import { AccountLayout } from "./AccountLayout";
import { useAuth } from "@/lib/auth";

/**
 * PortalShell — wraps a page inside the persistent left-nav shell
 * (header + sticky sidebar) for ANY signed-in account (client, staff,
 * admin, super_admin) so the main menu is visible on every page. Guests
 * (no user) get the children unchanged so public pages keep their
 * standalone layouts.
 *
 * `mainClassName` is forwarded to AccountLayout so pages that paint
 * their own background (e.g. the light-themed /book flow) can neutralise
 * the layout's default dark padding.
 *
 * `title` sets the small "/ …" breadcrumb inside the shell header.
 */
export const PortalShell = ({ children, title, mainClassName }) => {
    const { user } = useAuth();
    if (!user) return children;
    return (
        <AccountLayout title={title} mainClassName={mainClassName}>
            {children}
        </AccountLayout>
    );
};
